export type OrderMethod = 'asc' | 'desc';

export interface FeatureFlags {
  'FINDEV-780': boolean;
  UCT: boolean;
  MOCK_API: boolean;
  // TODO: remove these flags after API implemented
  UCT_PROCUREMENT: boolean;
  UCT_DISPUTE: boolean;
  UCT_LOGISTIC_RESULT: boolean;
  UCT_LOGISTIC_APPROVED: boolean;
  UCT_NO_APPROVAL: boolean;
  UCT_NO_DEVIATIONS: boolean;
  SHOW_SIDEBAR_NAV: boolean;
  SHOW_SERVER_ERROR_DETAIL: boolean;
  SHOW_ASK_FREYA: boolean;
  API_VERSION_SWITCH: boolean;
  DELETE_MODE_SWITCH: boolean;
  GUIDED_TOURS: boolean;
  SHOW_INVOICE_APPROVALS: boolean;
}

declare module 'axios' {
  export interface AxiosRequestConfig {
    meta?: {
      request?: {
        body?: any;
        url?: string;
        method?: string;
      };
    };
  }
}

export type Modality = 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
export const validModalities: Modality[] = ['AIR', 'COURIER', 'CT', 'RAIL', 'ROAD', 'SEA'];
export function castToModality(value: string): Modality | null {
  const isValid = validModalities.includes(value as Modality);
  if (!isValid) {
    console.error(`Invalid modality: ${value}. Expected one of: ${validModalities.join(', ')}`);
    return null;
  }
  return value as Modality;
}
export enum AddressType {
  PICK_UP = 'PICK_UP',
  DELIVERY = 'DELIVERY',
  LEGAL = 'LEGAL',
  BILLING = 'BILLING',
  OFFICE = 'OFFICE',
  HEAD_OFFICE = 'HEAD_OFFICE',
}
